
import React from 'react';
import { Bell, ShieldAlert, Truck, Mail } from 'lucide-react';
import { Card } from './SharedComponents';

export const SettingsNotifications = ({ isSuper }: { isSuper: boolean }) => (
  <Card className={`${isSuper ? 'bg-[#1e293b] border-white/5 p-10 text-white' : 'bg-white border-gray-100 p-10'} rounded-[40px] shadow-xl`}>
    <h3 className="text-2xl font-black uppercase tracking-tight mb-8">Central de Alertas</h3>
    <div className="space-y-4">
      <NotificationToggle icon={Bell} label="Novos Pedidos SaaS" isSuper={isSuper} />
      <NotificationToggle icon={ShieldAlert} label="Inadimplência de Locadoras" isSuper={isSuper} />
      <NotificationToggle icon={Truck} label="Status de Infraestrutura" isSuper={isSuper} />
    </div>
  </Card>
);

const NotificationToggle = ({ icon: Icon, label, isSuper }: any) => (
  <div className={`flex items-center justify-between p-6 rounded-3xl border ${isSuper ? 'bg-white/5 border-white/5' : 'bg-gray-50 border-gray-100'}`}>
    <div className="flex items-center gap-4">
      <div className="p-3 bg-primary/10 text-primary rounded-xl"><Icon size={20} /></div>
      <span className="font-bold uppercase text-xs tracking-widest">{label}</span>
    </div>
    <div className="w-12 h-6 bg-primary rounded-full p-1 flex justify-end">
      <div className="w-4 h-4 bg-white rounded-full"></div>
    </div>
  </div>
);
